/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _Math$sign from "@babel/runtime-corejs3/core-js-stable/math/sign";

/** @module browser/modules/element-utils/which-scroll-limit-reached */

/**
 * @description Indicates which scrolling limit has been reached if any.
 * @param {HTMLElement} elem - Element.
 * @param {number} deltaX - Scroll deltaX.
 * @param {number} deltaY - Scroll deltaY.
 * @returns {(string|null)} Result.
 */
function whichScrollLimitReached(elem, deltaX, deltaY) {
  var directionX = deltaX ? _Math$sign(deltaX) : null;
  var directionY = deltaY ? _Math$sign(deltaY) : null;

  if (!elem) {
    return null;
  }

  if (elem.scrollTop <= 0 && directionY === -1) {
    return 'top';
  } else if (elem.scrollTop + elem.clientHeight >= elem.scrollHeight - 1 && directionY === 1) {
    return 'bottom';
  } else if (elem.scrollLeft <= 0 && directionX === -1) {
    return 'left';
  } else if (elem.scrollLeft + elem.clientWidth >= elem.scrollWidth - 1 && directionX === 1) {
    return 'right';
  } else {
    return null;
  }
}

export { whichScrollLimitReached };